// extracted by mini-css-extract-plugin
module.exports = {"editData":"EditData_editData__2Ksiv","error":"EditData_error__COBox","submitPlc":"EditData_submitPlc__25cmP","disabled":"EditData_disabled__1AR8a"};